var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#29B6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 27.75C20.5858 27.75 20.25 28.0858 20.25 28.5C20.25 28.9142 20.5858 29.25 21 29.25V27.75ZM27 29.25C27.4142 29.25 27.75 28.9142 27.75 28.5C27.75 28.0858 27.4142 27.75 27 27.75V29.25ZM15.75 16.5C15.75 16.9142 16.0858 17.25 16.5 17.25C16.9142 17.25 17.25 16.9142 17.25 16.5H15.75ZM30.75 16.5C30.75 16.9142 31.0858 17.25 31.5 17.25C31.9142 17.25 32.25 16.9142 32.25 16.5H30.75ZM24 15.75H30V14.25H24V15.75ZM24.75 28.5V15H23.25V28.5H24.75ZM24 14.25H18V15.75H24V14.25ZM24 27.75H21V29.25H24V27.75ZM24 29.25H27V27.75H24V29.25ZM18 14.25C16.7574 14.25 15.75 15.2574 15.75 16.5H17.25C17.25 16.0858 17.5858 15.75 18 15.75V14.25ZM30 15.75C30.4142 15.75 30.75 16.0858 30.75 16.5H32.25C32.25 15.2574 31.2426 14.25 30 14.25V15.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 33.75C31.9142 33.75 32.25 33.4142 32.25 33C32.25 32.5858 31.9142 32.25 31.5 32.25V33.75ZM16.5 32.25C16.0858 32.25 15.75 32.5858 15.75 33C15.75 33.4142 16.0858 33.75 16.5 33.75V32.25ZM24 33.75H31.5V32.25H24V33.75ZM24 32.25H16.5V33.75H24V32.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceText);
export default __webpack_public_path__ + "static/media/resourceText.e7a1c39a8d433e05df4dff9a61fe3fa8.svg";
export { ForwardRef as ReactComponent };